export enum ProductTiers {
  APP = 'app',
}

export enum ProductCategories {
  KIT = 'Product Kit',
}

export enum Fit {
  REGULAR = 'regular',
  PETITE = 'petite',
  TALL = 'tall',
}

export const nullSizeChart = 'null-size-chart'
